import { IComparable, DataAndTypeModel } from 'src/shared/models';
export class ExpandableCardProperty extends DataAndTypeModel implements IComparable<ExpandableCardProperty> {
	public key: string;
	public label: string;
	public order: number;
	public isPrimaryKey?: boolean;

	public constructor(params: Partial<ExpandableCardProperty>) {
		super({ value: params.value, valueType: params.valueType });
		this.key = params.key;
		this.label = params.label;
		this.order = params.order;
		this.isPrimaryKey = params.isPrimaryKey;
	}

	public compare(obj: ExpandableCardProperty): boolean {
		return (
			obj.key === this.key &&
			obj.value === this.value &&
			obj.label === this.label &&
			obj.valueType === this.valueType &&
			obj.isPrimaryKey === this.isPrimaryKey
		);
	}
}

export class ExpandableCard implements IComparable<ExpandableCard> {
	public id: number;
	public title?: string;
	public secondTitle?: string;
	public properties: ExpandableCardProperty[];
	public isMaster: boolean;
	public isExpanded: boolean;
	public isOriginalSample?: boolean;
	public isStandard?: boolean;
	public isParent?: boolean;
	public isValid?: boolean = true;

	public constructor(params: Partial<ExpandableCard>) {
		this.id = params.id;
		this.title = params.title;
		this.secondTitle = params.secondTitle;
		this.properties = params.properties;
		this.isMaster = params.isMaster;
		this.isExpanded = params.isExpanded;
		this.isOriginalSample = params.isOriginalSample;
		this.isStandard = params.isStandard;
		this.isParent = params.isParent;
		this.isValid = params.isValid;
	}

	public compare(obj: ExpandableCard): boolean {
		return obj.id === this.id && this.compareItems(this.properties, obj.properties);
	}

	private compareItems(prev: ExpandableCardProperty[], curr: ExpandableCardProperty[]): boolean {
		for (let index = 0; index < prev.length; index++) {
			if (!prev[index].compare(curr[index])) {
				return false;
			}
		}
		return true;
	}

	public async
}
